<template>
  <div>
    <v-container class="storeinfo-container">
      <div class="header-container">
        <div class="address">
          <div>{{ storeInfo.address.address1 }}</div>
          <div>{{ storeInfo.mobile }}</div>
        </div>
        <div class="logo">
          <div class="discount-container">
            <template v-for="item in discounts">
              <div class="discount-item" v-if="item.enabled" :key="item.id">
                <template v-if="item.type === 0">
                  {{
                    $t("home.discount_price", {
                      total: item.threshold,
                      discount: item.discount
                    })
                  }}
                </template>
                <template v-if="item.type === 1">
                  {{
                    $t("home.discount_scale", {
                      total: item.threshold,
                      discount: item.discount
                    })
                  }}
                </template>
              </div>
            </template>
          </div>
          {{ storeInfo.name | uppercase }}
        </div>
        <div class="time">
          <div class="order-list-home" v-if="storeInfo.reserveStatus == 1">
            <router-link :to="{ name: 'reservar' }" class="reserva-btn">
              <div>
                {{ $t("home.reserva.button") }}
              </div>
              <div
                class="discount"
                v-if="
                  storeInfo.storeConf && storeInfo.storeConf.openReservDiscount
                "
              >
                <div
                  class="num"
                  v-if="
                    storeInfo.storeConf.reservDiscount &&
                      Number(storeInfo.storeConf.reservDiscount)
                  "
                >
                  -{{ storeInfo.storeConf.reservDiscount || 0 }}%
                </div>
                <div class="text">{{ $t("order.discount") }}</div>
              </div>
            </router-link>
          </div>
          <div class="time-title">
            {{ storeInfo.takeawayStatus == 0 ? $t("home.stop") : "" }}
          </div>
          <div class="time-title">
            {{ $t("home.status") }}：{{
              storeInfo.open ? $t("home.open") : $t("home.close")
            }}
          </div>
          <div
            v-for="(item, index) in storeInfo.todayBusinessHours"
            :key="index"
          >
            {{ item.startTime }} ~ {{ item.endTime }}
          </div>
        </div>
      </div>

      <!-- begin 推荐菜品 -->
      <div class="banner-container">
        <router-link
          class="banner-item"
          v-for="(item, index) in recommendDeliveries"
          :key="index"
          :to="{ name: 'delivery/detail', params: { id: item.guid } }"
        >
          <img class="cover" :src="item.cover.url" alt="" @load="loadImage" />
          <div class="itme-title">
            {{
              (item.commodity_name_json &&
                item.commodity_name_json[getTranslateIndex]) ||
                item.name
            }}
          </div>
          <div class="text">
            {{ item.description }}
          </div>
        </router-link>
      </div>
      <!-- end 推荐菜品 -->

      <!-- <img
                                      class="store-bg"
                                      :src="storeInfo.background.url"
                                      v-if="!!storeInfo.background"
                                      @load="loadImage"
                                    /> -->

      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        v-if="bannerList.length != 0"
        @slideChange="changeSwiper()"
      >
        <swiper-slide
          v-show="bannerList.length > 1"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img
            :src="item.shareImgs"
            class="banner-item"
            @click="handleBannerClick(item)"
            @load="loadImage"
          />
        </swiper-slide>
        <img
          :src="bannerList[0].shareImgs"
          class="banner-item"
          @click="handleBannerClick(item)"
          @load="loadImage"
          v-show="bannerList.length == 1"
        />
        <div
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
          v-show="bannerList.length > 1"
        ></div>
      </swiper>
    </v-container>

    <!-- begin 只支持到店取餐 提示 -->
    <v-container>
      <div class="takeaway-tip" v-if="storeInfo.takeawayStatus == 2">
        {{ storeInfo.closeShipReminder }}
      </div>
    </v-container>
    <!-- end 只支持到店取餐 提示 -->

    <div v-if="pageLoading" class="page-loading-container">
      <v-progress-circular
        :size="60"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <v-container class="menu-container" v-show="!pageLoading">
      <v-layout class="menu-layout" :column="breakpoint.mdAndDown">
        <v-flex
          class="sidebar"
          shrink
          xs2
          id="sidebar"
          v-show="!breakpoint.mdAndDown"
        >
          <div
            class="sidebar-wrapper"
            :class="{ 'fixed-bar': sidebarFixed, 'has-cookie': showCookie }"
          >
            <div class="menu-heading">
              <h4>
                {{ $t("delivery.menu_title") }}
              </h4>
            </div>
            <v-layout class="sidebar-nav" column>
              <div
                class="sidebar-nav__item"
                v-for="(item, index) in categoryList"
                :key="item.guid"
                :class="{ active: index === activeCategory }"
                @click="goAnchor($event, `#category-${index}`, index)"
              >
                {{
                  (item.category_name_json &&
                    item.category_name_json[getTranslateIndex]) ||
                    item.name
                }}
              </div>
            </v-layout>
          </div>
        </v-flex>

        <!-- begin pc 菜单  -->
        <v-flex
          class="menu-layout-content pc-menu-content"
          v-if="!breakpoint.mdAndDown"
          xs7
          id="pcMenu"
        >
          <div
            class="delivery"
            v-for="(category, index) in deliveryMenu"
            :key="category.guid"
            :id="`category-${index}`"
          >
            <div class="menu-heading">
              <h4>
                {{
                  (category.category_name_json &&
                    category.category_name_json[getTranslateIndex]) ||
                    category.name
                }}
              </h4>
            </div>
            <div
              :class="{
                'delivery-list-imgmode': storeInfo.isOrderPage == 1,
                'delivery-list': true
              }"
            >
              <v-layout
                class="delivery-list__item "
                align-center
                v-for="item in category.commodites"
                :key="item.guid"
              >
                <v-flex
                  shrink
                  @click="goToDetail(item.guid, 'detail')"
                  class="sidebar_img_box"
                >
                  <img
                    class="cover cover-img-poster"
                    :src="item.cover.url"
                    alt=""
                    :style="{ height: coverWith }"
                    v-if="storeInfo.isOrderPage == 1"
                  />
                  <img
                    class="cover"
                    :src="item.cover.url"
                    alt=""
                    v-if="storeInfo.isOrderPage != 1"
                  />
                  <!--                  <div-->
                  <!--                    class="cover"-->
                  <!--                    v-show="!item.cover.url"-->
                  <!--                    :style="{ height: coverWith }"-->
                  <!--                  ></div>-->
                </v-flex>
                <v-flex
                  class="delivery-info"
                  fill-height
                  @click="goToDetail(item.guid, 'detail')"
                >
                  <v-layout column fill-height justify-space-between>
                    <div class="delivery-title">
                      {{
                        (item.commodity_name_json &&
                          item.commodity_name_json[getTranslateIndex]) ||
                          item.name
                      }}
                      <span v-if="storeInfo.isOrderPage != 1">
                        <img
                          v-for="(allergenItem, index) in item.allergen"
                          :src="allergenItem.image"
                          :key="index"
                          class="allergen-img "
                          style="width: 20px"
                        />
                      </span>
                    </div>
                    <div
                      class="delivery-allergen-img"
                      v-if="storeInfo.isOrderPage == 1"
                    >
                      <img
                        v-for="(allergenItem, index) in item.allergen"
                        :src="allergenItem.image"
                        :key="index"
                        class="allergen-img"
                      />
                    </div>
                    <div class="delivery-content" style="white-space: pre-line">
                      {{
                        (item.description_json &&
                          item.description_json[getTranslateIndex]) ||
                          item.description
                      }}
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex fill-height>
                  <v-layout column align-end justify-space-between>
                    <v-flex
                      class="delivery-price"
                      shrink
                      style="min-width: 60px"
                    >
                      {{ item.takeawayPrice | fixed(2, true) }} €
                    </v-flex>
                    <v-flex
                      class="delivery-operate"
                      shrink
                      v-if="item.garnish.length == 0"
                    >
                      <i
                        class="iconfont icon-yichu icon"
                        @click="handleMinusFromCart(item.guid)"
                        v-if="item.num && storeInfo.takeawayStatus != 0"
                      ></i>
                      <div v-if="item.num && storeInfo.takeawayStatus != 0">
                        <span class="show-num" :key="item.num">
                          {{ item.num }}
                        </span>
                      </div>
                      <i
                        class="icon iconfont icon-plus icon"
                        v-show="storeInfo.takeawayStatus != 0"
                        @click="handleAddToCart(item, null, $event)"
                      ></i>
                    </v-flex>
                    <v-flex
                      class="delivery-operate"
                      shrink
                      v-if="
                        item.garnish.length != 0 &&
                          storeInfo.takeawayStatus != 0
                      "
                    >
                      <i
                        class="icon iconfont icon-plus icon"
                        @click="goToDetail(item.guid, 'garnish')"
                      ></i>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
        <!-- end pc 菜单  -->
        <v-flex
          v-if="sidebarFixed"
          style="max-width:400px;width: 400px;position: relative"
          class="pc-shopping-cart-content order_box"
          xs5
        ></v-flex>
        <!-- begin pc 购物车 -->
        <v-flex
          class="pc-shopping-cart-content order_box"
          xs4
          shrink
          v-resize="handleResize"
          id="order"
          v-show="storeInfo.takeawayStatus != 0"
          v-if="!breakpoint.mdAndDown"
        >
          <ShoppingCart
            :orderFixed="orderFixed"
            :discountAmount="discountAmount"
            :actuallyPaidAmount="actuallyPaidAmount"
            @change-delivery-type="changeDeliveryType"
            @handle-addto-cart="handleAddToCart"
            @handle-minus-fromcart="handleMinusFromCart"
            :showCart="showCart"
          />
        </v-flex>
        <!-- end pc 购物车 -->
        <!-- begin 移动端 菜单  -->
        <v-flex class="menu-layout-content" v-if="breakpoint.mdAndDown">
          <div
            class="delivery"
            v-for="(category, index) in deliveryMenu"
            :key="category.guid"
            :id="`category-${index}`"
          >
            <div
              class="menu-heading"
              @click="checkMenuIndex($event, `#category-${index}`, index)"
              :ref="`menu-title-${index}`"
            >
              <h4>
                {{
                  (category.category_name_json &&
                    category.category_name_json[getTranslateIndex]) ||
                    category.name
                }}
              </h4>
            </div>
            <div
              :class="{ 'menu-heading-fixed': true, 'has-cookie': showCookie }"
              v-if="activeCategoryPhone == index && showFixedTitle"
            >
              <div class="border">
                <h4>
                  {{
                    (category.category_name_json &&
                      category.category_name_json[getTranslateIndex]) ||
                      category.name
                  }}
                </h4>
              </div>
            </div>
            <div
              :class="{
                'delivery-list-imgmode': storeInfo.isOrderPage == 1,
                'delivery-list': true
              }"
              v-if="activeCategoryPhone == index"
            >
              <v-layout
                class="delivery-list__item"
                align-center
                v-for="item in category.commodites"
                :key="item.guid"
              >
                <v-flex shrink @click="goToDetail(item.guid, 'detail')">
                  <img
                    class="cover"
                    :src="item.cover.url"
                    alt=""
                    v-show="item.cover.url"
                  />
                  <div class="cover" v-show="!item.cover.url"></div>
                </v-flex>
                <v-flex
                  class="delivery-info"
                  fill-height
                  @click="goToDetail(item.guid, 'detail')"
                >
                  <v-layout column fill-height justify-space-between>
                    <div class="delivery-title" style="margin-bottom: 10px">
                      {{
                        (item.commodity_name_json &&
                          item.commodity_name_json[getTranslateIndex]) ||
                          item.name
                      }}
                    </div>
                    <div>
                      <img
                        v-for="(allergenItem, index) in item.allergen"
                        :src="allergenItem.image"
                        :key="index"
                        class="allergen-img"
                      />
                    </div>
                    <div
                      class="delivery-content"
                      style="margin-top: 10px;white-space: pre-line"
                    >
                      {{
                        (item.description_json &&
                          item.description_json[getTranslateIndex]) ||
                          item.description
                      }}
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex fill-height>
                  <v-layout column align-end justify-space-between>
                    <v-flex class="delivery-price" shrink>
                      €{{ item.takeawayPrice | fixed(2, true) }}
                    </v-flex>
                    <v-flex
                      class="delivery-operate"
                      shrink
                      v-if="item.garnish.length == 0"
                    >
                      <i
                        class="iconfont icon-yichu icon"
                        v-if="item.num && storeInfo.takeawayStatus != 0"
                        @click="handleMinusFromCart(item.guid)"
                      ></i>
                      <div v-if="item.num && storeInfo.takeawayStatus != 0">
                        <span class="show-num" :key="item.num">
                          {{ item.num }}
                        </span>
                      </div>
                      <i
                        class="icon iconfont icon-plus icon"
                        v-show="storeInfo.takeawayStatus != 0"
                        @click="handleAddToCart(item, null, $event)"
                      ></i>
                    </v-flex>
                    <v-flex
                      class="delivery-operate"
                      shrink
                      v-if="
                        item.garnish.length != 0 &&
                          storeInfo.takeawayStatus != 0
                      "
                    >
                      <i
                        class="icon iconfont icon-plus icon"
                        @click="goToDetail(item.guid, 'garnish')"
                      ></i>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
        <!-- end 移动端 菜单  -->

        <!-- begin 移动端 购物车 -->
        <v-flex
          class="menu-layout-content "
          xs4
          shrink
          v-resize="handleResize"
          id="order"
          v-show="storeInfo.takeawayStatus != 0"
          v-if="breakpoint.mdAndDown"
        >
          <ShoppingCart
            :orderFixed="orderFixed"
            :discountAmount="discountAmount"
            :actuallyPaidAmount="actuallyPaidAmount"
            @change-delivery-type="changeDeliveryType"
            @handle-addto-cart="handleAddToCart"
            @handle-minus-fromcart="handleMinusFromCart"
          />
        </v-flex>
        <!-- end 移动端 购物车 -->
      </v-layout>
    </v-container>

    <div class="cart-icon" @click="goToCart">
      <v-badge right overlap>
        <span class="cart-nums" v-if="cartNums > 0" :key="cartNums">{{
          cartNums
        }}</span>
        <img class="icon" src="../../assets/cart.png" />
      </v-badge>
    </div>

    <!-- begin 未在营业时间 -->
    <v-dialog v-model="isNotOpenError" vertical max-width="500px">
      <v-card color="primary">
        <v-card-title>
          <span>{{ $t("delivery.is_not_open_store") }}</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="isNotOpenError = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- end 未在营业时间 -->

    <!-- begin 选择属性 -->
    <v-dialog v-model="isShowAttributes" max-width="500px">
      <v-card color="#fff">
        <div
          class="attributes-container"
          v-if="attributes && attributes.length != 0"
        >
          <div class="attributes-title">
            <div>{{ $t("delivery_detail.remark") }}：</div>
            <!-- <input placeholder="输入或选择备注" /> -->
          </div>
          <div v-for="(cate, cateIndex) in attributes" :key="cate.guid">
            <div class="title">
              {{ cate.attr_cate_name }}（{{
                $t(cate.type === 0 ? "unClass.add389" : "unClass.add392", {
                  num: cate.min_limit
                })
              }}）
            </div>
            <div class="attributes-content">
              <div
                v-for="(item, index) in cate.attributes || []"
                :key="index"
                :class="{ item: true, active: item.check }"
                @click="checkAttr(item, cateIndex, index)"
              >
                {{ item.name }}{{ Number(item.price) ? ` €${item.price}` : `` }}
              </div>
            </div>
          </div>
        </div>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <button
                class="button shadow add-cart-button"
                @click="handleAddToCartAttributes($event)"
              >
                {{ $t("delivery_detail.addToCart") }}
              </button>
            </template>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- end 选择属性 -->

    <!-- bengin 动效小球 -->
    <div class="ball-container">
      <div v-for="(ball, index) in balls" :key="index">
        <transition
          name="cast-ball"
          @before-enter="ballBeforeEnter"
          @enter="ballEnter"
          @after-enter="ballAfterEnter"
        >
          <div class="horiz-ball" v-show="ball.show">
            <div class="ball"></div>
          </div>
        </transition>
      </div>
    </div>
    <!-- end 动效小球 -->

    <!--    提示输入zipcode-->
    <!--    <v-dialog v-model="keywordShow" :close-on-click-overlay="false" persistent vertical width="500px" >-->
    <!--      <v-card style="height: 200px;background: #ffffff">-->
    <!--&lt;!&ndash;        <van-field v-model="keywordNum" type="number" label="数字" />&ndash;&gt;-->
    <!--        <div class="keywordShow_box">-->
    <!--          <input v-model="keywordNum" type="text" placeholder="zipcode">-->
    <!--        </div>-->
    <!--        <div class="keywordShow_box_btn">确认</div>-->

    <!--      </v-card>-->
    <!--    </v-dialog>-->
    <v-dialog v-model="keywordShow" persistent width="500">
      <v-card>
        <!--        <v-card-title class="text-h5">-->
        <!--          Lo sentimos, de momento no realizamos pedidos en la zona especificada.-->
        <!--        </v-card-title>-->
        <v-card style="height: 230px;background: #ffffff">
          <!--        <van-field v-model="keywordNum" type="number" label="数字" />-->
          <div
            class="alert_text"
            style="color: red;height: 60px;padding-top: 16px"
          >
            <span>{{ $t("unClass.add400") }}</span>
          </div>
          <div class="keywordShow_box">
            <input v-model="keywordNum" type="text" placeholder="" />
          </div>
          <div
            class="keywordShow_box_btn"
            v-if="keywordShowBoxBtn == false"
            style="background: #266abd"
            @click="queryZipcodebtn"
          >
            Aceptar
          </div>
          <div
            class="keywordShow_box_btn"
            v-if="keywordShowBoxBtn != false"
            style="background: #266abd;opacity: 0.8;font-size: 16px"
            @click="queryZipcodebtn"
          >
            Aceptar
          </div>
          <div class="alert_text" style="height: 40px;">
            <span v-if="zipErr">{{ $t("unClass.add401") }}</span>
          </div>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import $ from "jquery";
import order from "@/api/order";
import publicApi from "@/api/public";
import { uppercase, fixed } from "../../utils";
import ShoppingCart from "./components/shopping-cart";

export default {
  data() {
    return {
      keywordShow: true,
      keywordNum: "",
      zipErr: false,
      leavePage: false,
      activeCategory: 0,
      offsetTop: 0,
      orderOffsetTop: 0,
      sidebarFixed: false,
      orderFixed: false,
      checked_guid: "",
      pageLoading: false,
      isNotOpenError: false,
      total: 0,
      discount: 0,
      discountAmount: 0,
      actuallyPaidAmount: 0,
      keywordShowBoxBtn: false,
      newPric: [],
      // 是否展示定位第一行的标题
      showFixedTitle: false,
      scrollTop: 0,
      balls: [
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false }
      ],
      castBalls: [],
      isShowAttributes: false,
      attributes: [],

      // 选中的菜品详情
      delivery: {
        guid: ""
      },

      dateFormat: new Date().toISOString().substr(0, 10),

      showCart: false,

      bannerList: [],

      swiperOptions: {
        loop: true,
        speed: 300,
        autoHeight: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      pcMenu: 0,
      suerLeav: false,
      coverWith: "auto"
    };
  },

  components: {
    ShoppingCart
  },
  created() {
    sessionStorage.removeItem("chooseTime");
    this.initData();

    if (localStorage.getItem("keyword") == "false") {
      if (localStorage.getItem("deliveryType") == "1") {
        this.keywordShow = true;
      } else {
        this.keywordShow = false;
      }
    } else {
      this.keywordShow = false;
      this.getStoreInfo();
    }

    this.getNewPirceInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    this.getOffset();
    const payload = {
      is_permitir_descuento: 1,
      items: this.cart.items.map(item => {
        return {
          commodityGuid: item.delivery.guid,
          customerGuid: this.guid,
          quantity: item.num,
          is_threshold: item.is_threshold,
          attributes: item.attributes,
          garnish: (item.garnish_items || []).map(item => {
            if (!item.quantity) item.quantity = 1;
            return { ...item };
          })
        };
      }),
      takeType: this.deliveryType == 0 ? "out" : "in"
    };

    this.calculateOrder(payload);
    this.getStoreInfo();
    this.getAllCoupons();
    this.getRecommendDelivery();
    this.getBannerList();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState([
      "deliveryMenu",
      "showCookie",
      "storeInfo",
      "userInfo",
      "isLogin",
      "activeCategoryPhone",
      "carts",
      "discounts",
      "recommendDeliveries",
      "storeId",
      "deliveryFee",
      "zipCode",
      "keyword",
      "deliveryType"
    ]),
    ...mapGetters(["categoryList", "cart", "getTranslateIndex"]),
    options() {
      return {
        duration: 800,
        offset: 152,
        easing: "easeInOutCubic"
      };
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    cartNums() {
      return this.cart.items.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.num;
      }, 0);
    }
  },
  methods: {
    ...mapMutations([
      "addToCart",
      "removeFromCart",
      "minusFromCart",
      "setActiveCategoryPhone",
      "resetCart",
      "setDelivery",
      "setDeliveryType",
      "setDeliveryFee",
      "setZipCode",
      "setStoreDeliveryArea"
    ]),
    ...mapActions([
      "getDeliveries",
      "getStoreInfo",
      "getAllCoupons",
      "getRecommendDelivery",
      "getThemeColor"
    ]),
    async queryZipcodebtn() {
      this.keywordShowBoxBtn = true;
      if (this.keywordNum == "") {
        this.$toasted.show(
          "Por favor, introduzca el código postal de su zona para que podamos ofrecerle un mejor servicio"
        );
        return false;
      } else {
        this.setZipCode(this.keywordNum);
      }
      let payload = {
        zipCode: this.keywordNum,
        storeGuid: this.storeInfo.guid,
        deliveryType: this.storeInfo.deliveryType
      };
      try {
        const {
          data: { isError, data }
        } = await order.queryZipcode(payload);
        this.keywordShowBoxBtn = false;
        if (isError) {
          this.zipErr = true;
          return;
        }

        this.keywordShow = false;
        this.zipErr = false;
        this.getNewPirceInfo();
        this.getStoreInfo();
        localStorage.setItem("keyword", true);
      } catch (e) {
        console.log(e);
      }
    },
    async getNewPirceInfo() {
      let payload = {
        storeGuid: this.storeInfo.guid
      };
      try {
        const {
          data: { isError, data }
        } = await order.storeDeliveryArea(payload);

        if (isError) {
          return;
        }
        if (data.length > 0) {
          this.newPric = data[0];
          this.setStoreDeliveryArea(data[0]);
        } else {
          this.newPric = data;
          this.setStoreDeliveryArea(data);
        }
        // this.newPric = data[0];
        // this.setStoreDeliveryArea(this.newPric);
      } catch (e) {
        console.log(e);
      }
    },

    async getBannerList() {
      try {
        const res = await publicApi.getDeliveyBanner({
          type: 0
        });

        if (!res.data.isError) {
          this.bannerList = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async calculateOrder(payload) {
      if (payload.items.length == 0) {
        return;
      }

      try {
        const {
          data: { isError, data }
        } = await order.calculateOrder(payload);

        if (isError) {
          return;
        }

        this.total = data.total;
        this.discount = data.discount;
        this.discountAmount = data.discountAmount;
        this.actuallyPaidAmount = data.actuallyPaidAmount;
        this.setDeliveryFee(data.deliveryFee);
      } catch (e) {
        console.log(e);
      }
    },

    goAnchor(e, selector, index) {
      if (e) {
        e.preventDefault();
      }
      this.activeCategory = index;
      this.$vuetify.goTo(selector, this.options);
    },

    handleScrollPhone() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.activeCategoryPhone != null) {
        let titleOffsetTop = 0;
        let nextTitleOffsetTop = 0;
        if (this.activeCategoryPhone != null) {
          titleOffsetTop = this.$refs[
            `menu-title-${this.activeCategoryPhone}`
          ][0].offsetTop;
          nextTitleOffsetTop = this.$refs[
            `menu-title-${this.activeCategoryPhone + 1}`
          ][0].offsetTop;
        }

        const cookieHeight = this.$vuetify.breakpoint.xs ? 80 : 60;
        const offset = this.showCookie ? 90 + cookieHeight : 90;

        if (
          titleOffsetTop - scrollTop < offset &&
          titleOffsetTop - scrollTop + (nextTitleOffsetTop - titleOffsetTop) >
            offset
        ) {
          this.showFixedTitle = true;
        } else {
          this.showFixedTitle = false;
        }
      }
    },

    loadImage() {
      this.getOffset();
    },

    handleScroll() {
      if (this.breakpoint.mdAndDown) {
        this.sidebarFixed = false;
        this.orderFixed = false;
        this.handleScrollPhone();
        return;
      }

      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      let offsetTop = this.offsetTop - 90;
      let orderOffsetTop = this.orderOffsetTop - 90 - 10;

      if (this.showCookie) {
        offsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
        orderOffsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
      }

      let sidebarFixed = scrollTop > offsetTop;
      let orderFixed = scrollTop > orderOffsetTop;
      this.sidebarFixed = sidebarFixed;
      this.orderFixed = orderFixed;

      let sidebarId = document.getElementById("sidebar");
      let pcMenuId = document.getElementById("pcMenu");
      let sidebarLeft = sidebarId.getBoundingClientRect().left;
      let sidebarWidth = sidebarId.offsetWidth;
      let pcMenuWidth = pcMenuId.offsetWidth;
      let left = sidebarLeft + pcMenuWidth + sidebarWidth;
      let box = document.getElementById("order");
      this.coverWith =
        document.querySelector(".cover-img-poster") &&
        document.querySelector(".cover-img-poster").getBoundingClientRect()
          .width + "px";

      let windowsH = document.documentElement.clientHeight - 150 - 40;
      if (sidebarFixed) {
        box.style.left = left + "px";
        box.style.top = "150px";
        box.style.position = "fixed";
        box.style.maxHeight = windowsH + "px";
      } else {
        box.style.position = "static";
        box.style.top = "0";
        box.style.left = "0";
      }
    },

    onProceedToCheckout() {
      if (
        // 配送
        this.deliveryType == 0 &&
        parseFloat(this.storeInfo.takeawayMinimumConsumption) >
          parseFloat(this.actuallyPaidAmount)
      ) {
        return;
      } else if (
        // 自取
        this.deliveryType == 1 &&
        parseFloat(this.storeInfo.takeMinAmount) >
          parseFloat(this.actuallyPaidAmount)
      ) {
        return;
      }

      if (!this.storeInfo.open) {
        this.isNotOpenError = true;
        return;
      }

      if (this.storeInfo.takeawayStatus == 0) {
        this.isNotOpenError = true;
        return;
      }

      this.$router.push({ name: "checkout" });
    },
    handleResize() {
      let orderWidth = "auto";
      let sidebarWidth = "auto";

      if (!this.breakpoint.mdAndDown) {
        orderWidth = $("#order").width();
        sidebarWidth = $("#sidebar").width();
      }

      $(".order").width(orderWidth);
      $(".sidebar-wrapper").width(sidebarWidth);

      let slide_height = $(window).height() - 200;

      if (!this.breakpoint.mdAndDown) {
        $(".order").css("max-height", slide_height + "px");
        $(".sidebar-wrapper").css("max-height", slide_height + "px");
      }
    },

    handleAddToCartAttributes(ev) {
      let selected = [];
      if (this.attributes && this.attributes.length) {
        let flag = true;
        this.attributes.map(cate => {
          if (cate.attributes) {
            cate.attributes.forEach(attr => {
              if (attr.check) {
                selected.push(attr.guid);
              }
            });
          }
        });
        this.attributes.forEach(item => {
          if (!this.$allowAddAttr(this.attributes, selected, null, item))
            flag = false;
        });
        if (!flag) return;
      }
      this.addToCart({
        num: 1,
        guid: this.delivery.guid,
        price: this.delivery.takeawayPrice,
        attributes: selected
      });

      this.isShowAttributes = false;
      this.castBall(ev.target);
    },

    handleAddToCart(item, index, ev) {
      this.delivery = item;
      if (
        !item.num &&
        item.attributes_cate &&
        item.attributes_cate.length != 0
      ) {
        this.attributes = item.attributes_cate;
        this.isShowAttributes = true;
      } else {
        const payload = {
          guid: item.guid,
          num: 1,
          price: item.takeawayPrice || item.delivery.takeawayPrice,
          index
        };

        this.checked_guid = item.guid;

        setTimeout(() => {
          this.checked_guid = "";
        }, 2000);

        this.addToCart(payload);
        this.castBall(ev.target);
      }
    },

    handleMinusFromCart(guid, index) {
      this.minusFromCart({
        num: 1,
        guid,
        index
      });
    },

    handleInputDescription(e, guid, index) {
      let carts = this.carts.slice();
      carts[index].description = e.target.value;
      this.resetCart(carts);
    },

    handleRemoveFromCart(guid, index) {
      this.removeFromCart({ guid, index });
    },
    getOffset() {
      this.$nextTick(function() {
        this.handleResize();
        const order = document.getElementById("order");
        this.orderOffsetTop = order.offsetTop;
        let header = document.getElementById("sidebar");
        this.offsetTop = header.offsetTop;
      });
    },
    goToCart() {
      if (window.scrollY === 0) {
        window.scrollTo(window.scrollX, 1);
      }
      this.$vuetify.goTo("#order", this.options);
      // this.showCart = !this.showCart;
      this.showCart = true;
    },
    goToDetail(guid, from) {
      this.$router.push({
        name: `delivery/detail`,
        params: { id: guid },
        query: { from }
      });
    },
    async initData() {
      this.pageLoading = this.deliveryMenu.length === 0;
      await this.getDeliveries();
      this.pageLoading = false;
    },

    // 切换 移动端展示菜单列表的下标
    checkMenuIndex(e, selector, index) {
      if (e) {
        e.preventDefault();
      }

      if (this.activeCategoryPhone == index) {
        this.setActiveCategoryPhone(null);
      } else {
        this.setActiveCategoryPhone(index);
      }

      const cookieHeight = this.$vuetify.breakpoint.xs ? 80 : 60;

      const options = {
        duration: 800,
        offset: this.showCookie ? 90 + cookieHeight : 90,
        easing: "easeInOutCubic"
      };

      setTimeout(() => {
        this.$vuetify.goTo(selector, options);
      }, 50);
    },

    /**
     * 选中可用小球
     */
    castBall(el) {
      // 找到第一个show为false（可用）的小球，然后就跳出循环
      this.balls.some(ball => {
        if (!ball.show) {
          ball.show = true;
          ball.el = el;
          this.castBalls.push(ball);
          return true;
        }
      });
    },

    ballBeforeEnter(el) {
      let len = this.balls.length;
      for (let i = 0; i < len; i++) {
        let ball = this.balls[i];
        if (ball.show) {
          let rect = ball.el.getBoundingClientRect();

          const winWidth = this.$vuetify.breakpoint.width;

          let x = rect.left - winWidth / 1.11;

          if (!this.breakpoint.mdAndDown) {
            x = rect.left - winWidth / 1.03;
          }
          let y = rect.top - window.innerHeight + 40;
          el.style.webkitTransform = `translate3d(${x}px,0,0)`;
          el.style.transform = `translate3d(${x}px,0,0)`;
          let child = el.children[0];
          child.style.transform = `translate3d(0,${y}px,0)`;
          child.style.webkitTransform = `translate3d(0,${y}px,0)`;
        }
      }
    },

    ballEnter(el, done) {
      el.timer = setTimeout(() => {
        el.style.webkitTransform = `translate3d(0,0,0)`;
        el.style.transform = `translate3d(0,0,0)`;
        let child = el.children[0];
        child.style.transform = `translate3d(0,0,0)`;
        child.style.webkitTransform = `translate3d(0,0,0)`;
        el.addEventListener("transitionEnd", done);
        el.addEventListener("webkitTransitionEnd", done);
      }, 30);
    },

    ballAfterEnter(el) {
      let ball = this.castBalls.shift();
      if (ball) {
        ball.show = false;
        el.style.display = "none";
        clearTimeout(el.timer);
      }
    },

    /**
     * 选择属性标签
     */
    checkAttr(item, cateIndex, index) {
      let attributes = JSON.parse(JSON.stringify(this.attributes));

      if (!attributes[cateIndex].attributes[index].check) {
        let selected = [];
        attributes.map(cate => {
          if (cate.attributes) {
            cate.attributes.forEach(att_item => {
              if (att_item.check) {
                selected.push(att_item.guid);
              }
            });
          }
        });
        if (!this.$allowAddAttr(attributes, selected, item.guid)) return;
      }

      attributes.map(cate => {
        if (cate.attributes) {
          cate.attributes.forEach(att_item => {
            if (att_item.guid === item.guid) {
              att_item.check = !att_item.check;
            }
          });
        }
      });

      let cart_attributes = [];
      attributes.map(cate => {
        if (cate.attributes) {
          cate.attributes.forEach(att_item => {
            if (att_item.check) {
              cart_attributes.push(att_item.guid);
            }
          });
        }
      });

      let carts = this.carts.slice(0);

      carts.map((item1, index) => {
        if (item1.guid == this.delivery.guid) {
          carts[index].attributes = cart_attributes;
        }
      });

      this.resetCart(carts);

      this.setDelivery({
        ...this.delivery,
        attributes
      });

      this.attributes = attributes;
    },

    // 切换配送/取餐
    changeDeliveryType(e) {
      this.setDeliveryType(e);
    },

    // 点击轮播图跳转
    handleBannerClick(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl, "_blank");
      } else if (item.linkType == 0 && item.linkGuid) {
        let menuIndex = null;
        this.deliveryMenu.map((_item, index) => {
          if (_item.guid == item.linkGuid) {
            menuIndex = index;
          }
        });

        if (!this.breakpoint.mdAndDown) {
          this.goAnchor("", `#category-${menuIndex}`, menuIndex);
        } else {
          this.checkMenuIndex("", `#category-${menuIndex}`, menuIndex);
        }
      } else if (item.linkType == 1 && item.linkGuid) {
        this.goToDetail(item.linkGuid, "detail");
      }
    },

    changeSwiper() {
      this.getOffset();
    }
    // leavebtn() {
    //   this.leavePage = false;
    //   this.suerLeav = true;
    //   this.$router.go(-1);
    //   console.log('测试')
    // }
  },

  watch: {
    "breakpoint.mdAndDown"() {
      this.getOffset();
      this.handleScroll();
    },
    offsetTop() {
      this.getOffset();
      this.handleScroll();
    },
    showCookie() {
      this.getOffset();
      this.handleScroll();
    },
    pageLoading() {
      this.getOffset();
      this.handleScroll();
    },
    userInfo(userInfo) {
      console.log(userInfo);
    },
    storeInfo(val, oldVal) {
      if (val.guid != oldVal.guid) {
        this.resetCart([]);
      }
    },
    deliveryType: {
      immediate: true,
      handler(items) {
        const payload = {
          is_permitir_descuento: 1,
          items: this.cart.items.map(item => {
            return {
              commodityGuid: item.delivery.guid,
              customerGuid: this.guid,
              quantity: item.num,
              is_threshold: item.is_threshold,
              attributes: item.attributes,
              garnish: (item.garnish_items || []).map(item => {
                if (!item.quantity) item.quantity = 1;
                return { ...item };
              })
            };
          }),
          takeType: this.deliveryType == 0 ? "out" : "in"
        };

        this.calculateOrder(payload);
      }
    },
    "cart.items": {
      immediate: true,
      handler(items) {
        console.log("测试监听购物车，cart.items", items);
        const payload = {
          is_permitir_descuento: 1,
          items: items.map(item => {
            return {
              commodityGuid: item.delivery.guid,
              customerGuid: this.guid,
              quantity: item.num,
              is_threshold: item.is_threshold,
              attributes: item.attributes,
              garnish: (item.garnish_items || []).map(item => {
                if (!item.quantity) item.quantity = 1;
                return { ...item };
              })
            };
          }),
          takeType: this.deliveryType == 0 ? "out" : "in"
        };

        this.calculateOrder(payload);

        // 通过对比购物车和菜单列表 在菜单列表加上数量num字段
        this.deliveryMenu.map((category_item, category_index) => {
          category_item.commodites &&
            category_item.commodites.map((item, index) => {
              this.deliveryMenu[category_index].commodites[index].num = 0;
              items.map(cart_item => {
                if (item.guid == cart_item.guid) {
                  this.deliveryMenu[category_index].commodites[index].num =
                    cart_item.num;
                }
              });
            });
        });
      }
    }
  },
  filters: {
    fixed,
    uppercase
  }
  // beforeRouteLeave(to, form, next) {
  //
  // }
};
</script>

<style scoped lang="sass" src="./delivery-list.sass"></style>
<style scoped lang="sass">
.keywordShow_box
    width: 300px
    margin: 0 auto

.keywordShow_box input
    width: 300px
    border: 1px solid #676767
    border-radius: 8px
    padding: 8px 12px

.keywordShow_box_btn
    width: 100px
    height: 40px
    text-align: center
    line-height: 40px
    color: #ffffff
    font-size: 18px
    margin: 30px auto 0
    background: var(--themeColor)
    border-radius: 2px

.alert_text
    width: 100%
    text-align: center
    margin-top: 10px

#order
    overflow-y: auto
    overflow-x: hidden
    max-width: 440px
    min-width: 400px

#order::-webkit-scrollbar
    display: none

.fixed-bar::-webkit-scrollbar
    display: none !important

.delivery-allergen-img
    height: 35px

.sidebar_img_box
/*height: 400px*/
/*border: 1px solid red*/
.delivery-list-imgmode
    .sidebar_img_box
        width: 100% !important

    .delivery-title
        text-align: center


.delivery-list-imgmode
    .cover
        width: 90% !important
        object-fit: cover
</style>
